import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import reducer from './reducer'
import './index.css'
import App from './components/App'
import registerServiceWorker from './registerServiceWorker'

const store = createStore(
    reducer,
    applyMiddleware(thunk)
)

render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('root')
);
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js